import React from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "../../../molecules";
import { DashboardIcon, ReportIcon, CreateBusinessIcon } from "../../../../assets/icons/sidebarIcon";

const Screen = () => {
  const navigate = useNavigate();
  return (
    <main className="container mx-auto">
      <div className="w-full h-fit flex flex-wrap items-stretch">
        <div className="md:w-3/6 w-full p-4">
          <Card desc={"Total Revenue Bisnis"} variant={"card-default"} icon={DashboardIcon} handler={() => navigate("/investor-dashboard")} />
        </div>
        <div className="md:w-3/6 w-full p-4">
          <Card desc={"Total Bisnis"} variant={"card-default"} icon={CreateBusinessIcon} handler={() => navigate("/our-business")} />
        </div>
        <div className="md:w-3/6 w-full p-4">
          <Card desc={"Value Bisniss"} variant={"card-default"} icon={ReportIcon} handler={() => navigate("/report")} />
        </div>
      </div>
    </main>
  );
};

export default Screen;
